<template>
  <div>
    <div
      class="border px-3 py-1"
      style="background-color: rgb(135 203 22 / 13%); height: 40px"
    >
      <p class="text-muted mt-1 mb-0">
        {{ $t('info_climates.data_comparison') }}
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'table-legend',
};
</script>
